import { render, staticRenderFns } from "./Qualification.vue?vue&type=template&id=01ffc862&scoped=true"
import script from "./Qualification.vue?vue&type=script&lang=js"
export * from "./Qualification.vue?vue&type=script&lang=js"
import style0 from "./Qualification.vue?vue&type=style&index=0&id=01ffc862&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ffc862",
  null
  
)

export default component.exports